import React, { Component } from "react";
import { Button, Popover, Modal } from "antd";
import { Form } from "informed";
import { TiDeleteOutline } from "react-icons/ti";
import { Row } from "react-bootstrap";
import { Input } from "../../common/forms/Input";
import { validateProperty } from "../../Validation/JoiValidation";
import { getLocalStorageValues } from "../../../services/boat";
import { DataContext } from "../BoatStore/BoatData";
import { IoChevronDownCircleOutline, IoChevronUpCircleOutline } from "react-icons/io5";
import { IoIosArrowDropup, IoIosArrowDropdown } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import { SlClose } from "react-icons/sl";
import { PiUserListThin } from "react-icons/pi";
import { PiUserList } from "react-icons/pi";
import { FcInfo } from "react-icons/fc";
import { PiSmileyStickerLight } from "react-icons/pi";
import { TbMoodSad } from "react-icons/tb";

export default class BoatSummaryCard extends Component {
  static contextType = DataContext;
  constructor(props) {
    super(props);
    this.state = {
      openEntranceAlert: false,
      openOkAlert: false,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const { ticketCart, ExpressboatCart, boatCart } = this.context.state;

    const ticketCartChanged = ticketCart?.length !== prevState.ticketCartLength;
    const expressboatCartChanged = ExpressboatCart?.length !== prevState.expressboatCartLength;
    const boatCartChanged = boatCart?.length !== prevState.boatCartLength;

    // Check if any relevant cart length has changed and if openOkAlert is not already true
    if ((ticketCartChanged || expressboatCartChanged || boatCartChanged)) {
      this.setState({
        openOkAlert: true,
        ticketCartLength: ticketCart?.length,
        expressboatCartLength: ExpressboatCart?.length,
        boatCartLength: boatCart?.length,
      });
    }
  }
  toggleShow = () => {
    this.setState(prevState => ({
      show: !prevState.show
    }));
  };

  // userInfoShow = () => {
  //   this.setState(prevState => ({
  //     showuser: !prevState.showuser
  //   }));
  // };  
  userInfoShow = () => {
    this.setState(prevState => ({
      showuser: !prevState.showuser,
      iconToggled: !prevState.iconToggled
    }));
  };

  showEntranceAlert = () => {
    this.setState({ openEntranceAlert: true })
  }

  handleOk = () => {
    this.setState({ openEntranceAlert: false, openOkAlert: false })
  }

  toggleShow1 = () => {
    this.setState(prevState => ({
      show: !prevState.show
    }));
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }


  render() {
    return (
      <>
        <div className="card">
          <div className="cart-heading text-center">Booking Details</div>
          <Row className="" style={{
            borderTop: 'solid 1px #000', fontFamily: "inter",
            boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
          }} >
            <div className="panel-body11 w-100">
              <div>
                <div className="d-flex justify-content-between">
                  {
                    <div className="roomlist w-100">
                      <div className="py-2">
                        <div className="mob-res d-flex flex-column">
                          {/*//! selected boats */}
                          {this.context.state.ticketCart?.length > 0 &&
                            this.context.state.ticketCart.map((boatcart) => {
                              return (
                                <>
                                  <div className="my-2 text-left d-flex data-card-color">

                                    <div className="col-md-5 p-0 cart-name">
                                      <span className="roomtypenamefont">{boatcart.BoatType}</span>
                                      <span className="small-font">
                                        {boatcart.SeaterType}
                                        <span className=" colorticket"> {boatcart.SlotType}</span>
                                      </span>
                                      <span className="small-font colorticket">
                                        {boatcart?.Timeslot?.SlotStartTime}
                                        {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                      </span>
                                    </div>

                                    <div className="bed-col col-md-3">
                                      <div className="d-flex justify-content-center mt-3">
                                        <span className="btn inc-dec-number roomCount colmargin">{boatcart.count} Ticket(s)</span>
                                      </div>
                                    </div>

                                    <div className="col-md-3 text-right amtmar">
                                      <span className="totaltarifffont">₹{parseInt((parseFloat(boatcart.NTBoatTotalCharge || 0) + parseFloat(boatcart.NTdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                    </div>

                                    <div className="col-md-1 text-right deleteicon " onClick={() => this.context.RemoveTicket(boatcart)}>
                                      <span className="totaltarifffont">
                                        <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                      </span>
                                    </div>

                                  </div>
                                </>
                              );
                            })}
                          {this.context.state.boatCart?.length > 0 &&
                            this.context.state.boatCart.map((boatcart) => {
                              return (
                                <>
                                  <div className="my-2 text-left d-flex data-card-color">
                                    <div className="col-md-5 p-0 cart-name">
                                      <span className="roomtypenamefont">{boatcart.BoatType}</span>
                                      <span className="small-font">
                                        {boatcart.SeaterType}
                                        <span className=" colorgreen"> {boatcart.SlotType}</span>
                                      </span>
                                      <span className="small-font colorgreen" style={{ color: 'green' }}>
                                        {boatcart?.Timeslot?.SlotStartTime}
                                        {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                      </span>
                                    </div>
                                    <div className="bed-col col-md-3">
                                      <div className="d-flex justify-content-center mt-3">
                                        <span className="btn inc-dec-number roomCount colmargin">{boatcart.count}{this.props.IsBoathouse ? " Boat(s)" : " Slot(s)"}</span>
                                      </div>
                                    </div>
                                    <div className="col-md-3 text-right amtmar">
                                      <span className="totaltarifffont">₹{parseInt((parseFloat(boatcart.BoatTotalCharge || 0) + parseFloat(boatcart.NBdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                    </div>
                                    <div className="col-md-1 text-right deleteicon " onClick={() => this.context.RemoveBoat(boatcart)}>
                                      <span className="totaltarifffont">
                                        <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                      </span>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          {this.context.state.ExpressboatCart?.length > 0 &&
                            this.context.state.ExpressboatCart.map((boatcart) => {
                              return (
                                <>
                                  <div className="my-2 text-left d-flex data-card-color">
                                    <div className="col-md-5 p-0 cart-name">
                                      <span className="roomtypenamefont">{boatcart.BoatType}</span>
                                      <span className="small-font">
                                        {boatcart.SeaterType} <span className=" colororange"> {boatcart.SlotType}</span>
                                      </span>
                                      <span className="small-font colororange">
                                        {boatcart?.Timeslot?.SlotStartTime}
                                        {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                      </span>
                                    </div>
                                    <div className="bed-col col-md-3">
                                      <div className="d-flex justify-content-center mt-3">
                                        <span className="btn inc-dec-number roomCount colmargin">{boatcart.count} Boat(s)</span>
                                      </div>
                                    </div>
                                    <div className="col-md-3 text-right amtmar">
                                      <span className="totaltarifffont">₹{parseInt((parseFloat(boatcart.ECBoatTotalCharge || 0) + parseFloat(boatcart.ECdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                    </div>
                                    <div className="col-md-1 text-right deleteicon " onClick={() => this.context.RemoveExpressBoat(boatcart)}>
                                      <span className="totaltarifffont">
                                        <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                      </span>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          {this.context.state.EntranceCart?.length > 0 &&
                            this.context.state.EntranceCart.map((service) => {
                              return (
                                <>
                                  <div className="my-2 text-left d-flex data-card-color">
                                    <div className="col-md-5 p-0 cart-name">
                                      <span className="roomtypenamefont">{service.CategoryName} </span>
                                      <span className="small-font">
                                        {service.ServiceName} (₹ {parseInt(service.ServiceTotalAmount || 0)} per person)
                                      </span>
                                    </div>
                                    <div className="bed-col col-md-3">
                                      <div className="d-flex justify-content-center mb-2">
                                        <button
                                          type="button"
                                          className="minus_infant colmargin"
                                          onClick={() => {
                                            this.context.decrementEntranceCart(service.ServiceId);
                                          }}
                                        >
                                          -
                                        </button>
                                        <span className="btn inc-dec-num roomCount colmargin">{service.count}</span>
                                        <button
                                          type="button"
                                          className="plus_infant colmargin"
                                          onClick={() => {
                                            this.context.incrementEntranceCart(service.ServiceId);
                                          }}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                    <div className="col-md-3 text-right amtmar">
                                      <span className="totaltarifffont">₹ {parseInt((service.ServiceTotalAmount || 0) * (service.count || 0))}</span>
                                    </div>
                                    <div className="col-md-1 text-right deleteicon" onClick={() => this.context.RemoveEntrance(service)}>
                                      <span className="totaltarifffont">
                                        <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                      </span>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          {/*//! selected other Services */}
                          {this.context.state.OtherserviceCart.length > 0 &&
                            this.context.state.OtherserviceCart.map((service) => {
                              return (
                                <>
                                  <div className="my-2 text-left d-flex data-card-color">
                                    <div className="col-md-5 p-0 cart-name">
                                      <span className="roomtypenamefont">{service.CategoryName}</span>
                                      <span className="small-font"> {service.ServiceName}</span>
                                    </div>
                                    <div className="bed-col col-md-3">
                                      <div className="d-flex justify-content-center mb-2">
                                        <button
                                          type="button"
                                          className="minus_infant colmargin"
                                          onClick={() => {
                                            this.context.decrementOtherService(service.ServiceId);
                                          }}
                                        >
                                          -
                                        </button>
                                        <span className="btn inc-dec-num roomCount colmargin">{service.count}</span>
                                        <button
                                          type="button"
                                          className="plus_infant colmargin"
                                          onClick={() => {
                                            this.context.incrementOtherService(service.ServiceId);
                                          }}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                    <div className="col-md-3 text-right amtmar">
                                      <span className="totaltarifffont">₹ {parseInt((service.ServiceTotalAmount || 0) * (service.count || 0))}</span>
                                    </div>
                                    <div className="col-md-1 text-right deleteicon" onClick={() => this.context.RemoveOtherservice(service)}>
                                      <span className="totaltarifffont">
                                        <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                      </span>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>



            {/* <hr className="hori-style" /> */}

            <div className="showmoreico">

              <div>
                {/* <div onClick={this.toggleShow} style={{ fontSize: '23px', marginLeft: '2rem' }} >
                  {this.state.show ? <IoIosArrowDropdown /> : <IoIosArrowDropup style={{ color: "black" }} />}
                </div> */}
                {/* {this.state.show ?   <IoIosArrowDropup />: <IoIosArrowDropup />  }   */}
                {/* {this.state.show && ( */}
                <div className="seltddtlsd">
                {(this.context.state.ticketCart?.length > 0 || 
                    this.context.state.boatCart?.length > 0 || 
                    this.context.state.ExpressboatCart?.length > 0 ||
                    this.context.state.EntranceCart?.length > 0 ||
                    this.context.state.OtherserviceCart.length > 0 ) && 
                    <div className="panel-body11 w-100">

                      {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: '0rem 1rem' }} >
                        <h4> Booking Details</h4>
                        <SlClose
                          size="22"
                          style={{ color: "red", cursor: "pointer" }}
                          onClick={this.toggleShow1}
                        />
                      </div> */}

                      <div>
                        <div className="d-flex justify-content-between">
                          {
                            <div className="roomlist w-100">
                              <div className="py-2">
                                <div className="mob-res d-flex flex-column ">
                                  {/*//! selected boats */}
                                  {this.context.state.ticketCart?.length > 0 &&
                                    this.context.state.ticketCart.map((boatcart) => {
                                      return (
                                        <>
                                          <div className="my-2 text-left d-flex data-card-color ">
                                            <div className="col-md-5 p-0 cart-name ">
                                              <span className="roomtypenamefont">{boatcart.BoatType}</span>
                                              <span className="small-font">
                                                {boatcart.SeaterType}
                                                <span className=" colorticket"> {boatcart.SlotType}</span>
                                              </span>
                                              <span className="small-font colorticket">
                                                {boatcart?.Timeslot?.SlotStartTime}
                                                {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                              </span>
                                            </div>
                                            <div className="bed-col col-md-3">
                                              <div className="d-flex justify-content-center mt-3">
                                                <span className="btn inc-dec-number roomCount colmargin">{boatcart.count} Ticket(s)</span>
                                              </div>
                                            </div>
                                            <div className="col-md-3 text-right amtmar">
                                              <span className="totaltarifffont">₹{parseInt((parseFloat(boatcart.NTBoatTotalCharge || 0) + parseFloat(boatcart.NTdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                            </div>
                                            <div className="col-md-1 text-right deleteicon " onClick={() => this.context.RemoveTicket(boatcart)}>
                                              <span className="totaltarifffont">
                                                <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                  {this.context.state.boatCart?.length > 0 &&
                                    this.context.state.boatCart.map((boatcart) => {
                                      return (
                                        <>
                                          <div className="my-2 text-left d-flex data-card-color">
                                            <div className="col-md-5 p-0 cart-name">
                                              <span className="roomtypenamefont">{boatcart.BoatType}</span>
                                              <span className="small-font">
                                                {boatcart.SeaterType}
                                                <span className=" colorgreen"> {boatcart.SlotType}</span>
                                              </span>
                                              <span className="small-font colorgreen" style={{ color: 'green' }}>
                                                {boatcart?.Timeslot?.SlotStartTime}
                                                {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                              </span>
                                            </div>
                                            <div className="bed-col col-md-3">
                                              <div className="d-flex justify-content-center mt-3">
                                                <span className="btn inc-dec-number roomCount colmargin">{boatcart.count} Boat(s)</span>
                                              </div>
                                            </div>
                                            <div className="col-md-3 text-right amtmar">
                                              <span className="totaltarifffont">₹{parseInt((parseFloat(boatcart.BoatTotalCharge || 0) + parseFloat(boatcart.NBdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                            </div>
                                            <div className="col-md-1 text-right deleteicon " onClick={() => this.context.RemoveBoat(boatcart)}>
                                              <span className="totaltarifffont">
                                                <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                  {this.context.state.ExpressboatCart?.length > 0 &&
                                    this.context.state.ExpressboatCart.map((boatcart) => {
                                      return (
                                        <>
                                          <div className="my-2 text-left d-flex data-card-color">
                                            <div className="col-md-5 p-0 cart-name">
                                              <span className="roomtypenamefont">{boatcart.BoatType}</span>
                                              <span className="small-font">
                                                {boatcart.SeaterType} <span className=" colororange"> {boatcart.SlotType}</span>
                                              </span>
                                              <span className="small-font colororange">
                                                {boatcart?.Timeslot?.SlotStartTime}
                                                {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                              </span>
                                            </div>
                                            <div className="bed-col col-md-3">
                                              <div className="d-flex justify-content-center mt-3">
                                                <span className="btn inc-dec-number roomCount colmargin">{boatcart.count} Boat(s)</span>
                                              </div>
                                            </div>
                                            <div className="col-md-3 text-right amtmar">
                                              <span className="totaltarifffont">₹{parseInt((parseFloat(boatcart.ECBoatTotalCharge || 0) + parseFloat(boatcart.ECdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                            </div>
                                            <div className="col-md-1 text-right deleteicon " onClick={() => this.context.RemoveExpressBoat(boatcart)}>
                                              <span className="totaltarifffont">
                                                <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                  {this.context.state.EntranceCart?.length > 0 &&
                                    this.context.state.EntranceCart.map((service) => {
                                      return (
                                        <>
                                          <div className="my-2 text-left d-flex data-card-color">
                                            <div className="col-md-5 p-0 cart-name">
                                              <span className="roomtypenamefont">{service.CategoryName} </span>
                                              <span className="small-font">
                                                {service.ServiceName} (₹ {parseInt(service.ServiceTotalAmount || 0)} per person)
                                              </span>
                                            </div>
                                            <div className="bed-col col-md-3">
                                              <div className="d-flex justify-content-center mb-2">
                                                <button
                                                  type="button"
                                                  className="minus_infant colmargin"
                                                  onClick={() => {
                                                    this.context.decrementEntranceCart(service.ServiceId);
                                                  }}
                                                >
                                                  -
                                                </button>
                                                <span className="btn inc-dec-num roomCount colmargin">{service.count}</span>
                                                <button
                                                  type="button"
                                                  className="plus_infant colmargin"
                                                  onClick={() => {
                                                    this.context.incrementEntranceCart(service.ServiceId);
                                                  }}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                            <div className="col-md-3 text-right amtmar">
                                              <span className="totaltarifffont">₹ {parseInt((service.ServiceTotalAmount || 0) * (service.count || 0))}</span>
                                            </div>
                                            <div className="col-md-1 text-right deleteicon" onClick={() => this.context.RemoveEntrance(service)}>
                                              <span className="totaltarifffont">
                                                <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                  {/*//! selected other Services */}
                                  {this.context.state.OtherserviceCart.length > 0 &&
                                    this.context.state.OtherserviceCart.map((service) => {
                                      return (
                                        <>
                                          <div className="my-2 text-left d-flex data-card-color">
                                            <div className="col-md-5 p-0 cart-name">
                                              <span className="roomtypenamefont">{service.CategoryName}</span>
                                              <span className="small-font"> {service.ServiceName}</span>
                                            </div>
                                            <div className="bed-col col-md-3">
                                              <div className="d-flex justify-content-center mb-2">
                                                <button
                                                  type="button"
                                                  className="minus_infant colmargin"
                                                  onClick={() => {
                                                    this.context.decrementOtherService(service.ServiceId);
                                                  }}
                                                >
                                                  -
                                                </button>
                                                <span className="btn inc-dec-num roomCount colmargin">{service.count}</span>
                                                <button
                                                  type="button"
                                                  className="plus_infant colmargin"
                                                  onClick={() => {
                                                    this.context.incrementOtherService(service.ServiceId);
                                                  }}
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </div>
                                            <div className="col-md-3 text-right amtmar">
                                              <span className="totaltarifffont">₹ {parseInt((service.ServiceTotalAmount || 0) * (service.count || 0))}</span>
                                            </div>
                                            <div className="col-md-1 text-right deleteicon" onClick={() => this.context.RemoveOtherservice(service)}>
                                              <span className="totaltarifffont">
                                                <IoCloseOutline size="22" style={{ color: "red", cursor: "pointer" }} />
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                }
                </div>
                {/* )} */}
              </div>

              <div className="sum-table">
                <table className="table summary-table">
                  <tbody>
                    {this.context.state.isAmountInfo && (
                      <>
                        <tr>
                          <th className="table-th">
                            <span className="bcharge">{this.props.IsBoathouse ? "Boat Charges" : "Booking Charges"}</span>
                          </th>

                          <td align="end">
                            <div id="bsgst1">₹ {parseFloat(this.context.state.BoatAmount || 0).toFixed(2)}</div>
                          </td>
                        </tr>
                        {this.context.state.RowerCharge === "00.00" || !this.props.IsBoathouse ? (
                          ""
                        ) : (
                          <tr>
                            <th className="table-th">
                              <span className="rcharge">Rower Charges</span>
                            </th>
                            <td align="end">
                              <div id="bsgst1">₹ {parseFloat(this.context.state.RowerCharge || 0).toFixed(2)}</div>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th className="table-th">
                            <span className="tcharge">GST</span>
                          </th>
                          <td align="end">
                            <div id="bsgst1">₹ {parseFloat(this.context.state.BoatTaxAmount || 0).toFixed(2)}</div>
                          </td>
                        </tr>
                        {this.context.state.DepositeAmount === 0 ? (
                          ""
                        ) : (
                          <tr>
                            <th className="table-th">
                              <span className="dCharge">Deposit</span>
                            </th>

                            <td align="end">
                              <div id="bsgst1">₹ {parseFloat(this.context.state.DepositeAmount || 0).toFixed(2)}</div>
                            </td>
                          </tr>
                        )}
                        {(this.context.state.OtherserviceCart?.length > 0 || this.context.state.EntranceCart?.length > 0) && (
                          <>
                            <tr>
                              <th className="table-th">
                                <span className="dCharge">Other Facilities</span>
                              </th>

                              <td align="end">
                                <div id="bsgst1">₹ {parseFloat((this.context.state.ServiceTotalAmount || 0) - (this.context.state.ServiceTaxAmount || 0)).toFixed(2)}</div>
                              </td>
                            </tr>
                            <tr>
                              <th className="table-th">
                                <span className="tcharge">GST</span>
                              </th>
                              <td align="end">
                                <div id="bsgst1">₹ {parseFloat(this.context.state.ServiceTaxAmount || 0).toFixed(2)}</div>
                              </td>
                            </tr>
                          </>
                        )}
                      </>
                    )}

                    <tr>
                      <th className="table-th">
                        <span className="tamountresponsive" style={{ borderBottom: "2px solid black" }}
                          onClick={this.context.showAmountInfo}>Total Amt</span>
                        <i id="pass-status" className={`${this.context.state.isAmountInfo ? "fa fa-angle-up" : "fa fa-angle-down"}`} aria-hidden="true" style={{ cursor: "pointer" }} onClick={this.context.showAmountInfo} />
                      </th>
                      <td>
                        <div id="" className="grandtotal">
                          ₹ {parseFloat(this.context.state.TotalAmount || 0).toFixed(2)}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2" className="text-center"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
            <div className="total-userinfo">

              <div className="fsumtable">
                <table className="table summary-table">
                  <tbody>

                    {this.state.show && (

                      <>
                        <div className="TotalAmount-Summary">

                          <tr>
                            <th className="table-th">
                              <span className="bcharge">{this.props.IsBoathouse ? "Boat Charges" : "Booking Charges"}</span>
                            </th>

                            <td align="end">
                              <div id="bsgst1">₹ {parseFloat(this.context.state.BoatAmount || 0).toFixed(2)}</div>
                            </td>
                          </tr>
                          {this.context.state.RowerCharge === "00.00" || !this.props.IsBoathouse ? (
                            ""
                          ) : (
                            <tr>
                              <th className="table-th">
                                <span className="rcharge">Rower Charges</span>
                              </th>
                              <td align="end">
                                <div id="bsgst1">₹ {parseFloat(this.context.state.RowerCharge || 0).toFixed(2)}</div>
                              </td>
                            </tr>
                          )}
                          <tr>
                            <th className="table-th">
                              <span className="tcharge">GST</span>
                            </th>
                            <td align="end">
                              <div id="bsgst1">₹ {parseFloat(this.context.state.BoatTaxAmount || 0).toFixed(2)}</div>
                            </td>
                          </tr>
                          {this.context.state.DepositeAmount === 0 ? (
                            ""
                          ) : (
                            <tr>
                              <th className="table-th">
                                <span className="dCharge">Deposit</span>
                              </th>

                              <td align="end">
                                <div id="bsgst1">₹ {parseFloat(this.context.state.DepositeAmount || 0).toFixed(2)}</div>
                              </td>
                            </tr>
                          )}
                          {(this.context.state.OtherserviceCart?.length > 0 || this.context.state.EntranceCart?.length > 0) && (
                            <>
                              <tr>
                                <th className="table-th">
                                  <span className="dCharge">Other Facilities</span>
                                </th>

                                <td align="end">
                                  <div id="bsgst1">₹ {parseFloat((this.context.state.ServiceTotalAmount || 0) - (this.context.state.ServiceTaxAmount || 0)).toFixed(2)}</div>
                                </td>
                              </tr>
                              <tr>
                                <th className="table-th">
                                  <span className="tcharge">GST</span>
                                </th>
                                <td align="end">
                                  <div id="bsgst1">₹ {parseFloat(this.context.state.ServiceTaxAmount || 0).toFixed(2)}</div>
                                </td>
                              </tr>
                            </>
                          )}
                        </div>

                      </>

                    )}
                    <tr onClick={this.toggleShow1} style={{ cursor: "pointer", position: "relative" }}  >
                      <th className="table-th" style={{ borderBottom: "1px solid black" }}>
                        <span className="tamountresponsive" onClick={this.context.state.isAmountInfo}>Total Amount</span>
                        <i id="pass-status" className={`${this.context.state.isAmountInfo ? "fa fa-angle-up" : "fa fa-angle-down"}`} aria-hidden="true" />
                      </th>
                      <td>
                        <div id="" className="grandtotal">
                          ₹ {parseFloat(this.context.state.TotalAmount || 0).toFixed(2)}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2" className="text-center"></td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <div className="w-100 userinfo-div">
                {/* {getLocalStorageValues("UserId") && (
                <div   onClick={this.userInfoShow} style={{display:"flex",columnGap:"1rem",alignItems:"center" ,cursor:"pointer",padding:"0px 13px",position:"relative"}} >
                  User Info
                  <PiUserList style={{fontSize:"22px",fontWeight:"700", }} /> 
                </div>
              )} */}



                <Form getApi={this.context.setFormApi} initialValues={{
                  MobileNo: getLocalStorageValues("MobileNo")?.length >= 10 && /^\d{10,}$/.test(getLocalStorageValues("MobileNo")) && getLocalStorageValues("MobileNo")
                  // , EmailId: getLocalStorageValues("EmailId") 
                }}>

                  {({ formApi, formState }) => (
                    <>
                      <div className="bcontinue">

                        {getLocalStorageValues("UserId") && this.state.showuser && (
                          <div className="mt-3 showUserInfo" id="userdet ">
                            <div>
                              <Input field="MobileNo" disabled={getLocalStorageValues("MobileNo")?.length >= 10 && /^\d{10,}$/.test(getLocalStorageValues("MobileNo")) ? true : false} placeholder="Mobile" validateOnBlur validate={(e) => validateProperty(true, "contact", e, "Mobile No")} />
                            </div>
                            {/* <div>
                            <Input field="EmailId" disabled={getLocalStorageValues("EmailId") ? true : false} placeholder="Email" validateOnBlur validate={(e) => validateProperty(true, "email", e, "EmailId")} />
                          </div> */}
                          </div>
                        )}
                        {getLocalStorageValues("UserId") && (
                          <div onClick={this.userInfoShow} style={{ display: "flex", columnGap: "1rem", alignItems: "center", cursor: "pointer", padding: "0px 13px", position: "relative", fontWeight: "600", }} >
                            User Info

                            {this.state.iconToggled ? (
                              <PiUserList style={{ fontSize: "22px", fontWeight: "700", color: "#157347" }} />
                            ) : (
                              <PiUserList style={{ fontSize: "22px", fontWeight: "700", color: "black" }} />
                            )}
                          </div>
                        )}





                        {this.context.state.noFacility === false && this.context.state.tabindex >= 0 ? (
                          <>

                            {this.context.state.OtherServicesList.length > 0 && this.context.state.ParkingList.length === 0 ? (
                              this.context.state.isParking === false &&
                                this.context.state.isOtherFacility === false ? (
                                <div className="text-center">
                                  <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg   text-light hotelbtn" onClick={() => this.context.ContinueButton("Other Facilities")}>
                                    Continue to Facilities
                                  </button>
                                </div>
                              ) : (
                                this.context.state.isParking === false &&
                                this.context.state.isOtherFacility === true && (
                                  <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg   text-light hotelbtn" onClick={() => this.context.ContinueButton("Other Facilities")}>
                                      Continue to Entrance Fee
                                    </button>
                                  </div>
                                )
                              )) : this.context.state.ParkingList.length > 0 && this.context.state.OtherServicesList.length === 0 ? (
                                this.context.state.isParking === false &&
                                  this.context.state.isOtherFacility === false ? (
                                  <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg text-light hotelbtn" onClick={() => this.context.ContinueButton("Other Facilities")}>
                                      Continue to Parking
                                    </button>
                                  </div>
                                ) : (
                                  this.context.state.isParking === true &&
                                  this.context.state.isOtherFacility === false && (
                                    <div className="text-center">
                                      <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg   text-light hotelbtn" onClick={() => this.context.ContinueButton("Other Facilities")}>
                                        Continue to Entrance Fee
                                      </button>
                                    </div>
                                  )
                                )
                              ) : this.context.state.ParkingList.length > 0 && this.context.state.OtherServicesList.length > 0 && this.context.state.isParking === false && this.context.state.isOtherFacility === false ? (
                                <div className="text-center">
                                  <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg  text-light hotelbtn" onClick={() => this.context.ContinueButton("Parking")}>
                                    Continue to Parking
                                  </button>
                                </div>
                              ) : this.context.state.isParking === true &&
                                this.context.state.isOtherFacility === true ? (
                              <div className="text-center">
                                <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg  text-light hotelbtn" onClick={() => this.context.ContinueButton("Parking")}>
                                  Continue to Entrance Fee
                                </button>
                              </div>
                            ) :
                              (
                                this.context.state.isParking === true &&
                                  this.context.state.isOtherFacility === false ? (
                                  <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg  text-light hotelbtn" onClick={() => this.context.ContinueButton("Parking")}>
                                      Continue to Facilities
                                    </button>
                                  </div>
                                ) : (this.context.state.ParkingList.length == 0 && this.context.state.OtherServicesList.length == 0 && this.context.state.isParking === false && this.context.state.isOtherFacility === false && this.context.state.EntranceList.length > 0 &&
                                  <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg  text-light hotelbtn" onClick={() => this.context.ContinueButton("Parking")}>
                                      Continue to Entrance Fee
                                    </button>
                                  </div>)
                              )}
                          </>
                        ) : getLocalStorageValues("UserId") ? (

                          this.context.state.noFacility === true && this.context.state.tabindex >= 0 ? (
                            <div className="text-center">
                              <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg   text-light hotelbtn"
                                disabled={this.context.state.ticketCart.length > 0 || this.context.state.boatCart.length > 0 || this.context.state.ExpressboatCart.length > 0 || this.context.state.OtherserviceCart.length > 0 || this.context.state.EntranceCart.length > 0 ? false : true}
                                //  onClick={this.context.boatBooking}
                                onClick={(this.context.state.EntranceCart?.length > 0 && (this.context.state.EntranceCart[0]?.["count"] < calculateTotalNoOfSeats([this.context.state.ticketCart, this.context.state.boatCart, this.context.state.ExpressboatCart])) && this.state.openOkAlert) ? this.showEntranceAlert : this.context.boatBooking}
                              >
                                PAY NOW
                              </button>
                            </div>
                          )
                            : this.context.state.noFacility === false && this.context.state.tabindex >= 0 && (
                              <div className="text-center">
                                <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg   text-light hotelbtn"
                                  disabled={this.context.state.ticketCart.length > 0 || this.context.state.boatCart.length > 0 || this.context.state.ExpressboatCart.length > 0 || this.context.state.OtherserviceCart.length > 0 || this.context.state.EntranceCart.length > 0 ? false : true}
                                  // onClick={this.context.boatBooking}
                                  onClick={(this.context.state.EntranceCart?.length > 0 && (this.context.state.EntranceCart[0]?.["count"] < calculateTotalNoOfSeats([this.context.state.ticketCart, this.context.state.boatCart, this.context.state.ExpressboatCart])) && this.state.openOkAlert) ? this.showEntranceAlert : this.context.boatBooking}
                                >
                                  PAY NOW
                                </button>
                              </div>)
                        ) : (
                          !getLocalStorageValues("UserId") && this.context.state.noFacility === true && this.context.state.tabindex >= 0 ? (
                            <div className="text-center">
                              <button className="btn btn-success mt-3 rounded-sm btn-lg   text-light hotelbtn"
                                onClick={() => this.context.checkloginData()}
                                disabled={this.context.state.ticketCart.length > 0 || this.context.state.boatCart.length > 0 || this.context.state.ExpressboatCart.length > 0 || this.context.state.OtherserviceCart.length > 0 || this.context.state.EntranceCart.length > 0 ? false : true}>
                                Book Now
                              </button>
                            </div>
                          ) : !getLocalStorageValues("UserId") && this.context.state.noFacility === false && this.context.state.tabindex >= 0 && (
                            <div className="text-center">
                              <button type="submit" className="btn btn-success mt-3 mb-2 rounded-sm btn-lg   text-light hotelbtn"
                                disabled={this.context.state.ticketCart.length > 0 || this.context.state.boatCart.length > 0 || this.context.state.ExpressboatCart.length > 0 || this.context.state.OtherserviceCart.length > 0 || this.context.state.EntranceCart.length > 0 ? false : true} onClick={() => this.context.checkloginData()}>
                                Book Now
                              </button>
                            </div>)
                        )
                        }

                      </div>
                    </>
                  )}

                </Form>


              </div>


              <div>
                {/* {this.context.state.EntranceCart?.length > 0 && this.context.state.EntranceCart[0]?.["count"] <= calculateTotalNoOfSeats([this.context.state.ticketCart,this.context.state.boatCart,this.context.state.ExpressboatCart]) &&
                        <div style={{fontSize:"10px",color:this.context.state.EntranceCart[0]?.["count"] == calculateTotalNoOfSeats([this.context.state.ticketCart,this.context.state.boatCart,this.context.state.ExpressboatCart]) ? "green":"red"}} className={this.context.state.EntranceCart[0]?.["count"] == calculateTotalNoOfSeats([this.context.state.ticketCart,this.context.state.boatCart,this.context.state.ExpressboatCart])? "" :"blink_me"}>
                          {this.context.state.EntranceCart[0]?.["count"] == calculateTotalNoOfSeats([this.context.state.ticketCart,this.context.state.boatCart,this.context.state.ExpressboatCart]) ? "The entrance counts are matched with the selected seats." :
                            `You have selected boats with a total of ${calculateTotalNoOfSeats([this.context.state.ticketCart,this.context.state.boatCart,this.context.state.ExpressboatCart])} seats. Therefore, ${calculateTotalNoOfSeats([this.context.state.ticketCart,this.context.state.boatCart,this.context.state.ExpressboatCart])} people can take a boat ride, and each member needs to pay an entrance fee.`}
                        </div>
                      } */}
                {
                  this.context.state.DepositeAmount !== 0 &&
                  <div className="note-deposite" style={{ color: "#0b5ed7", fontSize: "12px", padding: "0px 16px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <div> Note : The deposit refund amount will be credited to you within 2 to 3 working days.</div>
                  </div>
                }

                {/* <div className="guestpolicy">
                  By proceeding, you agree to our{" "}
                  <Popover
                    placement="leftTop"
                    content={
                      <>
                        <i>Policies to be included</i>
                      </>
                    }
                  >
                    <span
                      target="_blank"
                      style={{
                        color: "#73BE7B",
                        cursor: "pointer",
                      }}
                    >
                      Policies.
                    </span>
                  </Popover>
                </div> */}
              </div>
            </div>
          </Row>
          <Modal footer={[<Button key="submit" type="primary" onClick={this.handleOk}>OK</Button>]} title="Entrance Ticket Count Confirmed Lower Than Boat Seats" wrapClassName="Login__Modal" visible={this.state.openEntranceAlert && this.state.openOkAlert} closable={false}>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem", fontFamily: "Inter" }}>
              <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
                <div>
                  <FcInfo style={{ fontSize: "20px", fontWeight: "600" }} />
                </div>
                <div>
                  {`You have selected boats with a total of ${calculateTotalNoOfSeats([this.context.state.ticketCart, this.context.state.boatCart, this.context.state.ExpressboatCart])} seats. Therefore, ${calculateTotalNoOfSeats([this.context.state.ticketCart, this.context.state.boatCart, this.context.state.ExpressboatCart])} people can take a boat ride, and each member needs to pay an entrance fee.`}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
                <div>
                  <TbMoodSad style={{ fontSize: "20px", fontWeight: "600", color: "#ff4d4f" }} />
                </div>
                <div>
                  You can also get entrance tickets at the counter, but you will need to stand in the queue.
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
                <div>
                  <PiSmileyStickerLight style={{ fontSize: "20px", fontWeight: "600", color: "#157347" }} />
                </div>
                <div>
                  By booking your entrance tickets online for each members, you avoid standing in line at the counter.
                </div>
              </div>

            </div>
          </Modal>
        </div>
      </>
    );
  }
}

function calculateTotalNoOfSeats(lists) {
  let totalNoOfSeats = 0;

  lists.forEach(list => {
    list.forEach(item => {
      totalNoOfSeats += parseInt(item.NoOfSeats, 10);
    });
  });

  return totalNoOfSeats;
}
